export const apiDoMain = process.env.REACT_APP_BACKEND_APIDOMAIN
